module.exports = "https://static.wanderu.com/static/media/spinner.687f2a08.svg";